// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks-quote-container","author":"blocks-quote-author","quote":"blocks-quote-quote","inner":"blocks-quote-inner"};